/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Noopeninghourshint3Inputs */

const en_noopeninghourshint3 = /** @type {(inputs: Noopeninghourshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This listing will be shown without opening hours.`)
};

const de_noopeninghourshint3 = /** @type {(inputs: Noopeninghourshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Ort wird ohne Öffnungszeiten angezeigt.`)
};

/**
* | output |
* | --- |
* | "This listing will be shown without opening hours." |
*
* @param {Noopeninghourshint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const noopeninghourshint3 = /** @type {((inputs?: Noopeninghourshint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Noopeninghourshint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_noopeninghourshint3(inputs)
	return de_noopeninghourshint3(inputs)
});
export { noopeninghourshint3 as "noOpeningHoursHint" }